export default {
  colors() {
    return ['#f4dc42', '#45c5ef']
  }
}
